import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Logo from '../../components/Logo';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useToast } from '../../hooks/use-toast';
import { adminLogin } from '../../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(u, p);
      localStorage.setItem('alp_admin_token', token);
      navigate('/admin/dashboard');
    } catch (err) {
      toast({ title: 'Invalid credentials', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-alp-black flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <Logo size={64} />
          <h1 className="font-serif text-3xl text-alp-cream mt-4">Admin Access</h1>
          <p className="text-alp-gray text-sm">Australian Luxe Peptides</p>
        </div>
        {new URLSearchParams(window.location.search).get('expired') && (
          <div data-testid="session-expired-notice" className="border border-alp-gold/40 bg-alp-gold/10 rounded p-3 mb-5 text-alp-gold text-xs text-center tracking-wide">
            Your session timed out. Please sign in again to continue.
          </div>
        )}
        <form onSubmit={submit} className="border border-alp-line rounded p-7 bg-alp-card/40 space-y-5">
          <div>
            <Label className="text-xs tracking-[0.15em] uppercase text-alp-gray mb-2 block">Username</Label>
            <Input value={u} onChange={(e) => setU(e.target.value)} data-testid="admin-username-input" className="bg-alp-dark border-alp-line text-alp-cream" />
          </div>
          <div>
            <Label className="text-xs tracking-[0.15em] uppercase text-alp-gray mb-2 block">Password</Label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)} data-testid="admin-password-input" className="bg-alp-dark border-alp-line text-alp-cream" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-alp-gold text-alp-black px-8 py-3.5 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-alp-goldlight transition-colors disabled:opacity-60">
            <Lock size={15} /> {loading ? 'Signing In\u2026' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
